export const whatsapp = {
    namespaced: true,
    state: {
        name: '',
        data: []
    },
    getters: {
        getAll(state) {
            return state.data
        },

        getName(state){
            return state.name
        }
    },
    mutations: {
        ADD_LEAD(state, payload){
            state.data.push(payload)
        },

        SET_LEAD(state, payload){
            state.data[payload.id] = payload.data
        },

        REMOVE_LEAD(state, id){
            state.data.splice(id, 1)
        },

        CLEAR_LEAD(state){
            state.data = []
        }
    },
    actions: {
        addLead({ commit }, payload){
            commit('ADD_LEAD', payload)
        },

        setLead({ commit }, payload){
            commit('SET_LEAD', payload)
        },

        removeLead({ commit }, id){
            commit('REMOVE_LEAD', id)
        },

        clearLead({ commit }) {
            commit('CLEAR_LEAD')
        }
    }
}